export const REVIEW_CARD_MODE = {
  VIEW_MODE: 'viewMode',
  EDIT_MODE: 'editMode',
};

export const REVIEW_TYPE = {
  FACEBOOK_REVIEW: 'FacebookReview',
  CUSTOM_REVIEW: 'CustomReview',
};

export const FB_REVIEW_FILTER_KEY = {
  ALL: 'All',
  POSITIVE: 'Positive',
};

export const authorLimit = 30;
export const softLimit = 200;
export const hardLimit = 500;
export const MaxReviewsCount = 10;

export const POSITIVE_REVIEW_TYPE = 'Positive';
